// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__YWWBE","header":"PatientBlock_header__14Yh1","label":"PatientBlock_label__1d371","option":"PatientBlock_option__2TPUX"};